// Hook compartilhado do catálogo (TanStack Query). Mesmo queryKey em todas as telas => cache único.
import { useQuery } from "@tanstack/react-query";
import { loadCatalog } from "./registry-client.js";

// Onde buscar o catálogo: default = asset bundlado (roda sem back). Override via .env (VITE_CAPABILITIES_URL).
export const CATALOG_URL = import.meta.env.VITE_CAPABILITIES_URL ?? "/capabilities.json";

export function useCatalog() {
  return useQuery({
    queryKey: ["catalog", CATALOG_URL],
    queryFn: () => loadCatalog(CATALOG_URL),
    staleTime: Infinity,
  });
}
